import Box from "@mui/material/Box";

const BoxDX = (props: any) => {
  return <Box {...props} />;
};

export default BoxDX;
